import { render } from "./ConversationMessageContainer.vue?vue&type=template&id=36ce814e&scoped=true"
import script from "./ConversationMessageContainer.vue?vue&type=script&lang=js"
export * from "./ConversationMessageContainer.vue?vue&type=script&lang=js"

import "./ConversationMessageContainer.vue?vue&type=style&index=0&id=36ce814e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ce814e"]])

export default __exports__